import styled from 'styled-components'
import { Button } from 'components/atoms'

export const HeaderImage = styled.div`
  background: ${ (props) => props.theme.colors.weiss } 100% no-repeat;
  background-size: cover;
  background-image: url('${ (props) => props.imgSrc }');

  height: 190px;
  display: flex;
  align-items: flex-end;

  @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
    height: 250px;
    padding: 20px;
  }

  @media ${ (props) => props.theme.breakpoints.devices.min.md } {
    height: 300px;
    padding: 40px 20px;
  }

  @media ${ (props) => props.theme.breakpoints.devices.min.lg } {
    height: 350px;
    padding: 60px 30px;
  }
`

export const HeaderText = styled.div`
  position: relative;
  color: ${ (props) => props.theme.colors.weiss };

  padding: 10px;
  width: 100%;

  @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
    padding: 10px 20px;
    width: 50%;
  }

  @media ${ (props) => props.theme.breakpoints.devices.min.md } {
    padding: 20px;
  }

  @media ${ (props) => props.theme.breakpoints.devices.min.lg } {
    padding: 20px 30px;
    width: calc(5 / 12 * 100%);
  }

  &:before {
    background: ${ (props) => props.theme.colors['aok-gruen'] };
    mix-blend-mode: multiply;
    display: block;
    content: '';
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
`

export const HeadlineWrapper = styled.div`
  position: relative;
  font-size: 20px;
  font-weight: bold;
  line-height: 1.2;

  @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
    font-size: 25px;
    margin-bottom: 20px;
  }

  @media ${ (props) => props.theme.breakpoints.devices.min.md } {
    font-size: 28px;
  }
`

export const TextWrapper = styled.p`
  display: none;

  @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
    display: block;
    position: relative;
    margin-bottom: 0;
  }
`

export const SearchBarContainer = styled.div`
  background: transparent;
  padding: 0;

  @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
    padding: 20px;
    box-shadow: 1px 2px 1px 0 ${ (props) => props.theme.colors.boxShadow };
    background: ${ (props) => props.theme.colors['hintergrund-prio2'] };
  }

  @media ${ (props) => props.theme.breakpoints.devices.min.lg } {
    padding: 30px;
  }

  @media print {
    display: none;
  }
`

export const SearchBar = styled.div`
  @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
    margin-top: ${ (props) => (props.hasImage ? '-40px' : '0') };
  }

  @media ${ (props) => props.theme.breakpoints.devices.min.lg } {
    margin-top: ${ (props) => (props.hasImage ? '-60px' : '0') };
  }
`

export const SearchBarHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  .header-menu {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 30px;

    > button:first-child {
      margin-right: 30px;
    }

    @media ${ (props) => props.theme.breakpoints.devices.max.md }, print {
      flex-direction: column;
      align-items: flex-end;

      > button:first-child {
        padding-bottom: 10px;
        margin-right: 0;
      }

      > button:last-child {
        > span {
          padding-right: 30px;
        }
      }
    }
  }
`

export const CompareButton = styled(Button)`
  display: none;
  font-size: 18px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.39;
  letter-spacing: normal;
  color: ${ (props) => props.theme.colors['standard-schwarz'] };

  @media ${ (props) => props.theme.breakpoints.devices.min.sm } {
    min-width: auto;
    display: inline-block;
    white-space: nowrap;
    padding: 0;
    border: none;

    :hover,
    :active,
    :active:focus,
    :focus {
      color: ${ (props) => props.theme.colors['aok-gruen'] };
      background: transparent;
      padding: 0;
      box-shadow: none;
      border: none;
    }
  }

  .icon-f-compare {
    :before {
      color: ${ (props) => props.theme.colors['panel-inner-border'] };
      width: 25px;
      height: 21px;
    }
  }
`
